// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Улучшенные стили для графиков и карточек */

/* Общие стили для графиков */
.chart-card {
    border-radius: 8px !important;
    overflow: hidden !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid #e8e8e8 !important;
    margin-bottom: 16px !important;
  }
  
  .chart-card .ant-card-head {
    border-bottom: 1px solid #f0f0f0 !important;
    padding: 8px 16px !important;
  }
  
  .chart-card .ant-card-head-title {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #333 !important;
  }
  
  .chart-card .ant-card-body {
    padding: 0 !important;
  }
  
  /* Стили для canvas и контейнера */
  canvas.chartjs-render-monitor {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  .chart-container {
    width: 100% !important;
    position: relative !important;
    padding: 10px !important;
  }
  
  /* Стили для вкладок */
  .ant-tabs-tab {
    padding: 8px 12px !important;
    margin: 0 8px !important;
    font-size: 14px !important;
    border-radius: 4px 4px 0 0 !important;
    transition: all 0.3s !important;
  }
  
  .ant-tabs-tab-active {
    font-weight: 600 !important;
  }
  
  .ant-tabs-ink-bar {
    height: 3px !important;
    border-radius: 3px !important;
    background-color: #1677ff !important;
  }
  
  .ant-tabs-nav:before {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  
  /* Стили для легенды */
  .chartjs-legend-item {
    padding: 4px 8px !important;
    margin-right: 8px !important;
    border-radius: 4px !important;
    font-size: 12px !important;
    display: inline-flex !important;
    align-items: center !important;
  }
  
  .chartjs-legend-color {
    width: 12px !important;
    height: 12px !important;
    border-radius: 50% !important;
    margin-right: 4px !important;
  }
  
  /* Стили для карточек условий */
  .condition-card {
    border-radius: 8px !important;
    overflow: hidden !important;
    transition: all 0.3s !important;
    height: 100% !important;
  }
  
  .condition-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-3px) !important;
  }
  
  .condition-card .ant-card-head {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    padding: 10px 16px !important;
  }
  
  /* Стили для сравнения показателей */
  .stat-value {
    font-size: 15px !important;
    font-weight: 600 !important;
    margin-right: 8px !important;
  }
  
  .stat-label {
    font-size: 13px !important;
    color: #666666 !important;
  }
  
  .stat-percentage {
    display: inline-block !important;
    margin-left: 8px !important;
    padding: 1px 6px !important;
    border-radius: 12px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
  }
  
  .stat-percentage.positive {
    background-color: rgba(0, 195, 137, 0.1) !important;
    color: #1677ff !important;
  }
  
  .stat-percentage.negative {
    background-color: rgba(242, 57, 90, 0.1) !important;
    color: #f2395a !important;
  }
  
  /* Стили для адаптивности */
  @media (max-width: 768px) {
    .chart-card {
      margin-bottom: 12px !important;
    }
    
    .chart-container {
      height: 300px !important;
    }
    
    .ant-tabs-tab {
      padding: 6px 10px !important;
      margin: 0 4px !important;
      font-size: 13px !important;
    }

    .ant-tabs-tab:active {
      color: #1677ff;
    }

    .ant-tabs-tab:hover {
      color: #1677ff;
    }
  }
  
  /* Исправление для оси X (поворот меток) */
  .chartjs-axis-x .chartjs-tick {
    transform: rotate(-45deg) !important;
    transform-origin: top right !important;
    max-width: 100px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  /* Добавление тени и стилей при наведении на графики */
  .chart-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }
  
  /* Улучшение дизайна карточек с данными */
  .data-card {
    background-color: #fff !important;
    border-radius: 8px !important;
    padding: 16px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }
  
  .data-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    margin-bottom: 16px !important;
    color: #333 !important;
    border-bottom: 1px solid #f0f0f0 !important;
    padding-bottom: 8px !important;
  }
  
  .data-row {
    display: flex !important;
    justify-content: space-between !important;
    margin-bottom: 8px !important;
  }
  
  .data-label {
    color: #666 !important;
  }
  
  .data-value {
    font-weight: 500 !important;
  }
  
  /* Стили для пустого состояния */
  .empty-chart-state {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    height: 300px !important;
    color: #999 !important;
  }
  
  .empty-chart-icon {
    font-size: 48px !important;
    margin-bottom: 16px !important;
    color: #ccc !important;
  }
  
  .empty-chart-text {
    font-size: 14px !important;
  }

  div#rc-tabs-0-tab-2:focus{
    color: #1677ff !important;;
  }
  
  div#rc-tabs-0-tab-2:hover{
    color: #1677ff !important;;
  }
 
  .ant-tabs-tab:hover{
    color: #1677ff !important;
  }

  div#rc-tabs-0-tab-1:focus{
    color: #1677ff !important;;
  }
  
  div#rc-tabs-0-tab-1:hover{
    color: #1677ff !important;;
  }

  div#rc-tabs-0-tab-2:active{
    color: #1677ff !important;;
  }
  
  div#rc-tabs-0-tab-1:active{
    color: #1677ff !important;;
  }
  
  .ant-row.css-dev-only-do-not-override-wovxm8{
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/styles/compare-styles.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C,6BAA6B;AAC7B;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,mDAAmD;IACnD,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,2CAA2C;IAC3C,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA,kCAAkC;EAClC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;IAC1B,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA,sBAAsB;EACtB;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA,+BAA+B;EAC/B;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,uBAAuB;EACzB;;EAEA;IACE,oDAAoD;IACpD,sCAAsC;EACxC;;EAEA;IACE,uDAAuD;IACvD,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;IAChC,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,mDAAmD;IACnD,yBAAyB;EAC3B;;EAEA;IACE,mDAAmD;IACnD,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE;MACE,8BAA8B;IAChC;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,4BAA4B;MAC5B,wBAAwB;MACxB,0BAA0B;IAC5B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA,0CAA0C;EAC1C;IACE,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA,sDAAsD;EACtD;IACE,qDAAqD;EACvD;;EAEA,yCAAyC;EACzC;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,wBAAwB;IACxB,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;IACtB,2CAA2C;IAC3C,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,gCAAgC;EAChC;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kCAAkC;IAClC,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB","sourcesContent":["/* Улучшенные стили для графиков и карточек */\r\n\r\n/* Общие стили для графиков */\r\n.chart-card {\r\n    border-radius: 8px !important;\r\n    overflow: hidden !important;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\r\n    border: 1px solid #e8e8e8 !important;\r\n    margin-bottom: 16px !important;\r\n  }\r\n  \r\n  .chart-card .ant-card-head {\r\n    border-bottom: 1px solid #f0f0f0 !important;\r\n    padding: 8px 16px !important;\r\n  }\r\n  \r\n  .chart-card .ant-card-head-title {\r\n    font-size: 14px !important;\r\n    font-weight: 600 !important;\r\n    color: #333 !important;\r\n  }\r\n  \r\n  .chart-card .ant-card-body {\r\n    padding: 0 !important;\r\n  }\r\n  \r\n  /* Стили для canvas и контейнера */\r\n  canvas.chartjs-render-monitor {\r\n    display: block !important;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n  }\r\n  \r\n  .chart-container {\r\n    width: 100% !important;\r\n    position: relative !important;\r\n    padding: 10px !important;\r\n  }\r\n  \r\n  /* Стили для вкладок */\r\n  .ant-tabs-tab {\r\n    padding: 8px 12px !important;\r\n    margin: 0 8px !important;\r\n    font-size: 14px !important;\r\n    border-radius: 4px 4px 0 0 !important;\r\n    transition: all 0.3s !important;\r\n  }\r\n  \r\n  .ant-tabs-tab-active {\r\n    font-weight: 600 !important;\r\n  }\r\n  \r\n  .ant-tabs-ink-bar {\r\n    height: 3px !important;\r\n    border-radius: 3px !important;\r\n    background-color: #1677ff !important;\r\n  }\r\n  \r\n  .ant-tabs-nav:before {\r\n    border-bottom: 1px solid #f0f0f0 !important;\r\n  }\r\n  \r\n  /* Стили для легенды */\r\n  .chartjs-legend-item {\r\n    padding: 4px 8px !important;\r\n    margin-right: 8px !important;\r\n    border-radius: 4px !important;\r\n    font-size: 12px !important;\r\n    display: inline-flex !important;\r\n    align-items: center !important;\r\n  }\r\n  \r\n  .chartjs-legend-color {\r\n    width: 12px !important;\r\n    height: 12px !important;\r\n    border-radius: 50% !important;\r\n    margin-right: 4px !important;\r\n  }\r\n  \r\n  /* Стили для карточек условий */\r\n  .condition-card {\r\n    border-radius: 8px !important;\r\n    overflow: hidden !important;\r\n    transition: all 0.3s !important;\r\n    height: 100% !important;\r\n  }\r\n  \r\n  .condition-card:hover {\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\r\n    transform: translateY(-3px) !important;\r\n  }\r\n  \r\n  .condition-card .ant-card-head {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;\r\n    font-weight: 600 !important;\r\n    font-size: 14px !important;\r\n    padding: 10px 16px !important;\r\n  }\r\n  \r\n  /* Стили для сравнения показателей */\r\n  .stat-value {\r\n    font-size: 15px !important;\r\n    font-weight: 600 !important;\r\n    margin-right: 8px !important;\r\n  }\r\n  \r\n  .stat-label {\r\n    font-size: 13px !important;\r\n    color: #666666 !important;\r\n  }\r\n  \r\n  .stat-percentage {\r\n    display: inline-block !important;\r\n    margin-left: 8px !important;\r\n    padding: 1px 6px !important;\r\n    border-radius: 12px !important;\r\n    font-size: 11px !important;\r\n    font-weight: 600 !important;\r\n  }\r\n  \r\n  .stat-percentage.positive {\r\n    background-color: rgba(0, 195, 137, 0.1) !important;\r\n    color: #1677ff !important;\r\n  }\r\n  \r\n  .stat-percentage.negative {\r\n    background-color: rgba(242, 57, 90, 0.1) !important;\r\n    color: #f2395a !important;\r\n  }\r\n  \r\n  /* Стили для адаптивности */\r\n  @media (max-width: 768px) {\r\n    .chart-card {\r\n      margin-bottom: 12px !important;\r\n    }\r\n    \r\n    .chart-container {\r\n      height: 300px !important;\r\n    }\r\n    \r\n    .ant-tabs-tab {\r\n      padding: 6px 10px !important;\r\n      margin: 0 4px !important;\r\n      font-size: 13px !important;\r\n    }\r\n\r\n    .ant-tabs-tab:active {\r\n      color: #1677ff;\r\n    }\r\n\r\n    .ant-tabs-tab:hover {\r\n      color: #1677ff;\r\n    }\r\n  }\r\n  \r\n  /* Исправление для оси X (поворот меток) */\r\n  .chartjs-axis-x .chartjs-tick {\r\n    transform: rotate(-45deg) !important;\r\n    transform-origin: top right !important;\r\n    max-width: 100px !important;\r\n    white-space: nowrap !important;\r\n    overflow: hidden !important;\r\n    text-overflow: ellipsis !important;\r\n  }\r\n  \r\n  /* Добавление тени и стилей при наведении на графики */\r\n  .chart-card:hover {\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\r\n  }\r\n  \r\n  /* Улучшение дизайна карточек с данными */\r\n  .data-card {\r\n    background-color: #fff !important;\r\n    border-radius: 8px !important;\r\n    padding: 16px !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;\r\n  }\r\n  \r\n  .data-title {\r\n    font-size: 16px !important;\r\n    font-weight: 600 !important;\r\n    margin-bottom: 16px !important;\r\n    color: #333 !important;\r\n    border-bottom: 1px solid #f0f0f0 !important;\r\n    padding-bottom: 8px !important;\r\n  }\r\n  \r\n  .data-row {\r\n    display: flex !important;\r\n    justify-content: space-between !important;\r\n    margin-bottom: 8px !important;\r\n  }\r\n  \r\n  .data-label {\r\n    color: #666 !important;\r\n  }\r\n  \r\n  .data-value {\r\n    font-weight: 500 !important;\r\n  }\r\n  \r\n  /* Стили для пустого состояния */\r\n  .empty-chart-state {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    height: 300px !important;\r\n    color: #999 !important;\r\n  }\r\n  \r\n  .empty-chart-icon {\r\n    font-size: 48px !important;\r\n    margin-bottom: 16px !important;\r\n    color: #ccc !important;\r\n  }\r\n  \r\n  .empty-chart-text {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  div#rc-tabs-0-tab-2:focus{\r\n    color: #1677ff !important;;\r\n  }\r\n  \r\n  div#rc-tabs-0-tab-2:hover{\r\n    color: #1677ff !important;;\r\n  }\r\n \r\n  .ant-tabs-tab:hover{\r\n    color: #1677ff !important;\r\n  }\r\n\r\n  div#rc-tabs-0-tab-1:focus{\r\n    color: #1677ff !important;;\r\n  }\r\n  \r\n  div#rc-tabs-0-tab-1:hover{\r\n    color: #1677ff !important;;\r\n  }\r\n\r\n  div#rc-tabs-0-tab-2:active{\r\n    color: #1677ff !important;;\r\n  }\r\n  \r\n  div#rc-tabs-0-tab-1:active{\r\n    color: #1677ff !important;;\r\n  }\r\n  \r\n  .ant-row.css-dev-only-do-not-override-wovxm8{\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    justify-content: center;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
